import axios from 'axios';
import {base_api} from './base';

export function getCompanies(includeDeleted) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Company?includeDeleted=${includeDeleted}`, {headers});
}

export function getCompanyById(companyId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Company/GetById?companyId=${companyId}`, {headers});
}

export function getCompanyByName(companyName) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Company/GetByName?companyName=${companyName}`, {headers});
}

export function addCompany(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Company/AddCompany`, data, {headers});
}

export function updateCompany(companyId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Company/UpdateCompany?companyId=${companyId}`, data, {headers});
}

export function deleteCompany(companyId, hardDelete) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Company/DeleteCompany?companyId=${companyId}&hardDelete=${hardDelete}`, {headers});
}

export function uploadLogo(companyId, file) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Company/UploadLogo?companyId=${companyId}`, file, {headers});
}




// WEBPACK FOOTER //
// ./src/services/Companies.service.js